import { Appear } from "@/components/appear";
import styled from "@emotion/styled";
import { MDSListBox, MDSSection, MDSText, MDSTextVariant } from "@/mds";

export const StyledPageWrapper = styled(Appear)({
  position: "relative",
  height: "100%",
  display: "flex",
  flexDirection: "column",
});

export const StyledContentWrapper = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing[2],
  fontSize: theme.fontSizes.small,
  lineHeight: theme.lineHeights.small,
  alignItems: "flex-start",
  color: theme.colors.grey.x700,
  flex: "1 0 0",
  overflow: "auto",
  scrollbarWidth: "none",
  "&::-webkit-scrollbar": {
    display: "none",
  },
  padding: theme.spacing[7],
}));

export const StyledContentSectionTitleWrapper = styled.div(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing.xsPlus,
  color: theme.colors.text.contrast,
  fontSize: theme.fontSizes.large,
  fontWeight: theme.fontWeights.semiBold,
  lineHeight: theme.lineHeights[MDSTextVariant.HeaderS],
  letterSpacing: "-0.2px",
  margin: 0,

  "& img": {
    width: "16px",
    height: "16px",
  },
}));

export const StyledCardIntegrationInstruction = styled(MDSSection)`
  display: flex;
  width: 784px;
  padding: ${({ theme }) => theme.spacing[5]} 0;
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing.smPlus};
`;

export const StyledContentList = styled.ul(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing[1],
  margin: 0,
  padding: `0 ${theme.spacing[5]} 0 ${theme.spacing[10]}`,
  fontSize: theme.fontSizes.medium,
  color: theme.colors.text.primary,
  lineHeight: theme.lineHeights.medium,
  alignItems: "flex-start",
  alignSelf: "stretch",

  li: {
    color: theme.colors.text.primary,
    fontSize: theme.fontSizes[MDSTextVariant.ParagraphS],
    fontWeight: theme.fontWeights.regular,
    lineHeight: theme.lineHeights[MDSTextVariant.ParagraphS],
  },
}));

export const StyledListBox = styled(MDSListBox)`
  margin-top: ${({ theme }) => theme.spacing[2]};
  margin-left: ${({ theme }) => theme.spacing[5]};
`;

export const StyledContentStatusWrapper = styled.div<{ isConnected?: boolean }>(
  ({ theme, isConnected }) => ({
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.xs,
    fontSize: theme.fontSizes.small,
    fontWeight: theme.fontWeights.smedium,
    lineHeight: theme.lineHeights.xsmall,
    color: theme.colors.text.contrast,

    "& svg": {
      color: isConnected ? theme.colors.green.x500 : theme.colors.red.x500,
    },
  })
);

export const StyledHeading = styled(MDSText)(({ theme }) => ({
  padding: `${theme.spacing[4]} ${theme.spacing[7]} ${theme.spacing[2]} 0`,
  textTransform: "uppercase",
  letterSpacing: "0.24px",
}));

export const StyledExplanation = styled(MDSText)`
  max-width: 784px;
`;

export const StyledSubTitle = styled(MDSText)``;

export const StyledSubExplanation = styled(MDSText)(({ theme }) => ({
  fontSize: theme.fontSizes.xsmall,
  color: theme.colors.text.secondary,
  lineHeight: theme.lineHeights.xsmall,
  margin: 0,
}));

export const StyledContentListTextContainer = styled.div(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing[1],

  "& svg": {
    color: theme.colors.green.x500,
  },
}));

export const StyledFormattingContentLeftAddon = styled.div`
  margin-top: ${({ theme }) => theme.spacing.xsPlus};
`;

export const StyledFormattingContentRightAddon = styled.div``;
